import type { LogLevel } from "@/data/model/Enums";

import { BaseServiceDao } from "./BaseServiceDao";

export class LogsDao extends BaseServiceDao {
    public static className = "LogsDao";

    constructor() {
        super("logs");
    }

    public async addMessage(message: string, level: LogLevel): Promise<void> {
        return this.post("add-log-message", {
            message: message,
            level: level,
        });
    }
}
